/* tslint:disable */
/* eslint-disable */
/**
 * Coworker IAM API
 * Provides coworker identity and access management functionalities
 *
 * The version of the OpenAPI document: 1.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MessageResponseDto
 */
export interface MessageResponseDto {
    /**
     * Response message
     * @type {string}
     * @memberof MessageResponseDto
     */
    message: string;
}

/**
 * Check if a given object implements the MessageResponseDto interface.
 */
export function instanceOfMessageResponseDto(value: object): boolean {
    if (!('message' in value)) return false;
    return true;
}

export function MessageResponseDtoFromJSON(json: any): MessageResponseDto {
    return MessageResponseDtoFromJSONTyped(json, false);
}

export function MessageResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function MessageResponseDtoToJSON(value?: MessageResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'message': value['message'],
    };
}

